import PropTypes from "prop-types"
import React from "react"
import Form from "semantic-ui-react/dist/es/collections/Form/Form"
import Label from "semantic-ui-react/dist/es/elements/Label/Label"

const WorksheetField = ({ children, hint, error, fieldWidth }) => {
  return (
    <Form.Field
      error={!!error}
      width={fieldWidth}
      className="Worksheet__WorksheetField"
    >
      {children}
      {hint ? (
        <Label pointing="abose" horizontal>
          {hint}
        </Label>
      ) : null}
    </Form.Field>
  )
}

WorksheetField.displayName = "WorksheetField"

WorksheetField.propTypes = {
  hint: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
}

WorksheetField.defaultProps = {
  fieldWidth: 16
}
export default WorksheetField
